import React, {useEffect} from "react";
import {IoIosArrowForward} from "react-icons/io";
import {useStateValue} from "../states/StateProvider";

const MilestoneTabs = ({label, done, lastIndex, id, loading, roleIndicator, abgesagt}) => {

    const [{currentMilestone}, dispatch] = useStateValue();

    function setMilestone() {
        if (!loading) {
            dispatch({type: "SET_CURRENTMILESTONE", item: id})
        }
    }

    return (<div onClick={setMilestone} className="flex items-center">
        <p className={`${currentMilestone.toString() === id ? 'border-mainBlue text-mainBlue' : done === '1' ? 'bg-complete border-lightgrey' : 'bg-pending border-lightgrey'}
                ${lastIndex.toString() === id && 'bg-whiteDark'} 
                m-1 text-sm border-2 px-2 py-1 cursor-pointer text-left flex-1
                ${abgesagt && id === '99' ? 'bg-borderRed id' : ''}`}
        >
            <div className="flex justify-between items-center w-full">
                    <span className="flex items-center gap-1">
                        {label}
                    </span>
                <IoIosArrowForward className="flex-shrink-0"/>
            </div>
        </p>
        {roleIndicator && (
            <span className={`inline-flex items-center justify-center w-2 h-4 text-xs font-bold rounded-full ${roleIndicator === 'A' ? 'text-mainBlue' : 'text-orange'}`}>
                {roleIndicator}
            </span>
        )}
    </div>)
}

export default MilestoneTabs
